import React from 'react';
import completeIcon from '../../assets/complete.png';
import { message, Modal, Tooltip } from 'antd';
import { useDocument } from '../../context/documentInfoContex';
import { workwiseServices } from '../../api';

const { confirm } = Modal;

const CompleteDocument = () => {
    const { documentInfo, setIsReadOnly, } = useDocument();

    const handleClick = async () => {
        try {
            await workwiseServices.completeDocument(documentInfo.referenceId);
            message.success('Document completed successfully.');
            setIsReadOnly(true);
        } catch (error) {
            message.error('Failed to complete the document. Please try again.');
        }
    };

    const showConfirmationModal = (e) => {
        e.preventDefault();
        confirm({
            title: 'Are you sure you want to complete this document?',
            content: 'This action cannot be undone.',
            onOk() {
                handleClick();
            },
            onCancel() {
            },
            zIndex: 9999,
            maskClosable: true,
        });
    };

    return (
        <Tooltip title='Complete Document'>
            <div
                style={{
                    marginLeft: "8px",
                    cursor: 'pointer'
                }}
                onClick={(e) => showConfirmationModal(e)}
            >
                <img src={completeIcon} width={24} alt="Complete Document" />
            </div>
        </Tooltip>
    );
};

export default CompleteDocument;